import "./OnSiteCardiologyServices.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Link } from "@/components/common/Link";
export default function OnSiteCardiologyServicesPage() {
  return <div>
      <Header />
      <section className="bg-[var(--color-dark-navy)] pt-32 pb-16 px-6 lg:px-12 font-default">
        <p className="text-sm uppercase tracking-widest text-red-500 mb-4">Services</p>
        <h1 className="font-bold text-3xl md:text-4xl uppercase tracking-tight text-white mb-6">Exceptional Cardiology Services</h1>
        <p className="text-lg text-soft-gray max-w-3xl">Your quality of life can depend on the health of your heart. When you choose Florida Premier Cardiology, you have access to advanced cardiovascular care at our Delray Beach and Boynton Beach offices, along with personalized attention focused on your individual needs.</p>
        <p className="text-lg text-soft-gray max-w-3xl mt-4">Our entire staff makes every effort to develop personal and caring relationships with our patients and their families.</p>
      </section>
      <section className="bg-background text-foreground py-16 px-6 lg:px-12 font-default">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Convenient On-Site Testing and Treatments:</h2>
            <ul className="list-disc list-inside text-base text-soft-gray leading-relaxed space-y-2">
              <li>Echocardiography</li>
              <li>Nuclear stress testing at both offices</li>
              <li>Pacemaker and device monitoring at both offices</li>
              <li>Vascular ultrasound</li>
              <li>Electronic medical records (EMR)</li>
              <li>Endovascular treatment for varicose veins at our Delray Beach office</li>
            </ul>
          </div>
          <div>
            <h2 className="font-bold text-2xl md:text-3xl uppercase tracking-tight mb-4 text-red-500">Get a Comprehensive Evaluation</h2>
            <p className="text-base text-soft-gray leading-relaxed">The advantage is clear. Being able to have your procedure completed at our clinic means one less trip to the hospital. For many of our patients, this is a welcome benefit. In addition to our on-site services, you can also get a <Link to="/delray-beach-fl/cardiac-evaluations/" className="text-red-500 underline">comprehensive evaluation</Link> for your specific cardiovascular condition.</p>
          </div>
        </div>
      </section>
      <section className="bg-[var(--color-dark-navy)] py-16 px-6 lg:px-12 font-default text-center">
        <p className="text-white text-lg max-w-2xl mx-auto mb-8">Ready to schedule your on-site testing or treatment? Contact our team today.</p>
        <Link to="/contact-us/" className="inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-10 py-5 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200">Contact Us</Link>
      </section>
      <Footer />
    </div>;
}
